// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function clearFormikFields(formik: any, fields: string[]): void {
    fields.forEach((field) => {
        formik.setFieldValue(field, '', false)
    })
}
